import ICaseSummary from "../case/ICaseSummary";
import IUser from "../user/IUser";

export enum NewsArticleType {
    Internal = 'Internal',
    External = 'External',
    File = 'File'
}

export default interface INewsArticle {
    id: number
    title: string;
    body?: string;
    excerpt?: string;
    imageUrl?: string;
    externalUrl?: string;
    fileId?: string;
    type: NewsArticleType;
    case: ICaseSummary;
    created: number;
    createdBy: IUser;
    publishDate?: number;
    publishedBy: IUser;
    nextArticleId?: number;
}